import "./error-message.scss";
const ErrorMessage = ({ errorMessage, boldDesc }) => {
  return (
    <div>
      <p className="error-message">
        {errorMessage ||
          "Something went wrong while fetching the details. Please try again by scanning the QR"}
      </p>
      {boldDesc && <p className="bold-error-description">{boldDesc}</p>}
    </div>
  );
};

export default ErrorMessage;
